export enum AiBotSettingsEndpoint {
  ROOT = '/chat-settings',
  CHANNEL = '/channel',
}

export const getAiBotSettingsEndpoints = ({ channelSlug }: { channelSlug: string }) => ({
  GET_AI_BOT_SETTINGS: `${AiBotSettingsEndpoint.ROOT}${AiBotSettingsEndpoint.CHANNEL}/${channelSlug}`,
  UPDATE_AI_BOT_SETTINGS: `${AiBotSettingsEndpoint.ROOT}${AiBotSettingsEndpoint.CHANNEL}/${channelSlug}`,
});

export interface IAiBotSettings {
  channelId: number;
  channelSlug: string;
  senderName: string | null;
  mainColor: string | null;
  welcomeMessage: string | null;
  disclaimerMessage: string | null;
  enabledForBot: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  channel: string;
}

// ============== DTO ==============

export interface IGetAiBotSettingsDTO {
  channelSlug: string;
}

export interface IUpdateAiBotSettingsDTO {
  channelSlug: string;
  senderName?: string;
  mainColor?: string;
  welcomeMessage?: string;
  disclaimerMessage?: string;
}

// ============== Response ==============

export type IGetAiBotSettingsResponse = IAiBotSettings;

export type IUpdateAiBotSettingsResponse = IAiBotSettings;
